export default __webpack_public_path__ + "static/media/parking.7a21ce84.mp4";